import { LinkedinIcon, MailIcon, MapPinIcon, PhoneIcon } from "lucide-react"
import Map from "./Map"

export default function Footer2() {
  return (
    <footer className="bg-zinc-950 text-zinc-300 py-16 border-t border-zinc-800">
      <div className="container mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8">
          {/* Company Branding & Description */}
          <div className="lg:col-span-4">
            <h2 className="text-white font-bold text-2xl mb-4 text-balance">Coghlan, Welsh & Guest</h2>
            <p className="text-zinc-400 leading-relaxed mb-6 text-pretty">
              Professional consulting and business services in Harare, Zimbabwe. Trusted expertise for your business
              needs.
            </p>
            <div className="flex gap-4">
              <a
                href="mailto:email@cwg.co.zw"
                target="_blank"
                rel="noopener noreferrer"
                className="h-10 w-10 rounded-full bg-zinc-900 hover:bg-zinc-800 transition-colors flex items-center justify-center"
                aria-label="Email us"
              >
                <MailIcon className="h-5 w-5 text-zinc-300" />
              </a>
              <a
                href="https://www.linkedin.com/company/coghlan-welsh-and-guest/"
                target="_blank"
                rel="noopener noreferrer"
                className="h-10 w-10 rounded-full bg-zinc-900 hover:bg-zinc-800 transition-colors flex items-center justify-center"
                aria-label="Visit our LinkedIn"
              >
                <LinkedinIcon className="h-5 w-5 text-zinc-300" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-zinc-400 hover:text-white transition-colors inline-block">
                  Home
                </a>
              </li>
              <li>
                <a href="/OurProfile" className="text-zinc-400 hover:text-white transition-colors inline-block">
                  Our Profile
                </a>
              </li>
              <li>
                <a href="/insights" className="text-zinc-400 hover:text-white transition-colors inline-block">
                  Services
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="lg:col-span-3">
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPinIcon className="h-5 w-5 text-zinc-400 flex-shrink-0 mt-0.5" />
                <span className="text-zinc-400 text-sm leading-relaxed">
                  Cecil House 2 Central Avenue (corner Second Street), Harare, Zimbabwe
                </span>
              </li>
              <li className="flex items-start gap-3">
                <MailIcon className="h-5 w-5 text-zinc-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:email@cwg.co.zw" className="text-zinc-400 hover:text-white transition-colors text-sm">
                  email@cwg.co.zw
                </a>
              </li>
              {/* <li className="flex items-start gap-3">
                <PhoneIcon className="h-5 w-5 text-zinc-400 flex-shrink-0 mt-0.5" />
                <div className="text-sm text-zinc-400 space-y-1">
                  <a href="tel:+263242794930" className="hover:text-white transition-colors block">
                    +263-242-794930
                  </a>
                  <a href="tel:+263242704933" className="hover:text-white transition-colors block">
                    +263-242-704933
                  </a>
                  <a href="tel:+263242704935" className="hover:text-white transition-colors block">
                    +263-242-704935
                  </a>
                  <a href="tel:+263712237347" className="hover:text-white transition-colors block">
                    +263-712-237347
                  </a>
                  <a href="tel:+263772161230" className="hover:text-white transition-colors block">
                    +263-772-161230
                  </a>
                </div>
              </li> */}
            </ul>
          </div>

          {/* Map Section */}
          <div className="lg:col-span-3">
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Location</h3>
            <div className="aspect-video rounded-lg overflow-hidden border border-zinc-800">
              <Map />
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-zinc-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-zinc-500">
            <p>&copy; {new Date().getFullYear()} Coghlan, Welsh & Guest. All rights reserved.</p>
            <a href="mailto:lusenakalee@gmail.com;sharahwa@gmail.com" className="hover:text-zinc-300 transition-colors">
              Designed by Shungu Harahwa & Leroy Lusenaka
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
